import { Routes } from "@angular/router";
import { ListaTipoComponent } from "./tipo/lista/lista.component";
import { ListEmpresaComponent } from "./empresa/list/list.component";
import { ListModoEntradaComponent } from "./modo-entrada/list/list.component";
import { ListRemitentesComponent } from "./remitentes-destinatarios/list-remitentes/list-remitentes.component";
import { ListUsuariosComponent } from "./usuarios/list-usuarios/list-usuarios.component";
import { BandejaComponent } from "../bandeja/bandeja.component";

export const catalogosDashboard: Routes = [
  { path: "administracion/catalogos/tipo", component: ListaTipoComponent },
  { path: "administracion/catalogos/empresa", component: ListEmpresaComponent },
  {
    path: "administracion/catalogos/modo-entrada",
    component: ListModoEntradaComponent,
  },
  {
    path: "administracion/catalogos/remitentes",
    component: ListRemitentesComponent,
  },
  {
    path: "administracion/catalogos/usuarios",
    component: ListUsuariosComponent,
  },
  {
    path: "bandeja",
    component: BandejaComponent,
  },
];
